import { UserOutlined, CaretDownOutlined } from "@ant-design/icons";
import { Popover } from "antd";
import Avatar from "antd/lib/avatar/avatar";
import React, { FC } from "react";
import styled from "styled-components";
// import ProfileAvatar from "../assets/images/profileAvatar.png";
// import Dashboard from "../assets/images/dashboard.png";
// import LogOutIcon from "../assets/images/logOut.png";
import { MdOutlineDashboard } from 'react-icons/md';
import { AiOutlineDownload } from 'react-icons/ai'
import { BiUserCircle } from 'react-icons/bi'
import { RiLogoutBoxRLine } from 'react-icons/ri'
import { useMutation } from '@apollo/client'
import { UPDATE_USER } from '../Apollo/graphql/Mutation/UserMutations';

import {
  removeCookie,
  removeUserId,
  removeUserData,
  setUserData,
  getUserData,
} from "../utils/utilsFunctions";
import { useHistory } from "react-router-dom";

interface DProps {
  color?: string;
}

const MainDiv = styled.div<DProps>`
  display: flex;
  background-color: transparent;
  justify-content: center;
  align-items: center;
  position: relative;
  top: 0;
  color: ${(props) => (props.color ? props.color : "#000")};
  cursor: pointer;

  @media screen and (max-width: 768px) {
        display: none;
    }
`;
const AvatarX = styled.div`
  padding: 0;
`;
const NameDiv = styled.div`
  margin: 0 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 16px;
  font-family: "Rogan", -apple-system, BlinkMacSystemFont, sans-serif;
`;
const MainSection = styled.div`
  /* width: 180px; */
  background: white;
  display: flex;
  padding: 1rem 0.5rem;
  font-size: 24px;
  line-height: 24px;
  font-family: "Rogan", -apple-system, BlinkMacSystemFont, sans-serif;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  z-index: 999;
`;
const IconDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`
const IconSection = styled.div`
  display: flex;

  &:hover{
    color: #1196DD;
  }
`
const Span = styled.span`
  margin-left: 1rem;

  /* &:active{
    border-bottom: 2px solid #1196DD;
  } */
`;
const Pop: FC<DProps> = ({ color }) => {

  const [updateUserMutation] = useMutation(UPDATE_USER);
  const user = JSON.parse(getUserData('user'));

  const isSeller = user?.isSeller === true;
  // const isPaymentSetUpComplete = user.paymentSetupComplete === true;

  const onClickSellerHandler = async () => {
    await updateUserMutation({
      variables: {
        userId: user?._id,
        input: {
          isSeller: true
        }
      }
    })
      .then((data) => {
        setUserData(JSON.stringify(data.data.updateUser));
      })
      .catch((err) => console.log('Something went wrong!', err))

    history.push('/start-selling')
  }


  const history = useHistory();
  const userLogout = () => {
    removeCookie();
    removeUserId();
    removeUserData();
    window.location.search = '';
    window.location.pathname = '/';
  };

  const content = (
    <MainSection>
      <IconDiv>
        <IconSection onClick={() => history.push("/dashboard/profile")}>
          <BiUserCircle />
          <Span>Profile</Span>
        </IconSection>
        <hr style={{ width: '100%' }} />
      </IconDiv>
      <IconDiv>
        <IconSection onClick={() => history.push("/dashboard/orders")}>
          <MdOutlineDashboard />
          <Span>Dashboard</Span>
        </IconSection>
        <hr style={{ width: '100%' }} />
      </IconDiv>
      {
        !isSeller && (
          <IconDiv>
            <IconSection onClick={onClickSellerHandler}>
              <Span>Become a Seller</Span>
            </IconSection>
            <hr style={{ width: '100%' }} />
          </IconDiv>
        )
      }
      <IconDiv>
        <IconSection onClick={() => history.push("/dashboard/inbox")}>
          <AiOutlineDownload />
          <Span>Inbox</Span>
        </IconSection>
        <hr style={{ width: '100%' }} />
      </IconDiv>
      <IconDiv>
        <IconSection onClick={userLogout}>
          <RiLogoutBoxRLine />
          <Span>Log out</Span>
        </IconSection>
      </IconDiv>
    </MainSection>
  );

  return (
    <>
      <Popover trigger="click" placement="bottomRight" content={content}>
        <MainDiv color={color}>
          <AvatarX>
            <Avatar size="large" style={{ background: '#000' }} icon={<UserOutlined />} />
            {/* <img src={user && user.avatarUrl ? user.avatarUrl : <UserOutlined />} alt="" /> */}
          </AvatarX>
          <NameDiv>
            <span>Hello,</span>
            <span>{user && user?.firstName ? user.firstName : ""}</span>
          </NameDiv>
          <CaretDownOutlined />
        </MainDiv>
      </Popover>
    </>
  );
};
export default Pop;
